// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fChz","title":"styles_title__2Nn3g"};